import { getJson, postJson, requestVoid } from './client';

// --- Types (partner SpaceBookmarkController) ---

export type SpaceBookmarkItem = {
  bookmarkId: string;
  spaceId: string;
  name: string;
  roadAddress: string | null;
  createdAt: string;
};

export type SpaceBookmarksPage = {
  items: SpaceBookmarkItem[];
  nextCursor: string | null;
  hasNext: boolean;
  totalCount: number | null;
  size: number;
};

// --- Functions ---

export function addSpaceBookmark(spaceId: string | number) {
  return postJson<unknown>(`/api/v1/spaces/${spaceId}/bookmark`, {});
}

export function removeSpaceBookmark(spaceId: string | number) {
  return requestVoid(`/api/v1/spaces/${spaceId}/bookmark`, { method: 'DELETE' });
}

export function getMySpaceBookmarks(params: { cursor?: string; size?: number } = {}) {
  const query = new URLSearchParams();
  if (params.cursor) query.set('cursor', params.cursor);
  if (params.size != null) query.set('size', String(params.size));
  const qs = query.toString();
  return getJson<SpaceBookmarksPage>(`/api/v1/users/me/bookmarks/spaces${qs ? `?${qs}` : ''}`);
}

/**
 * 단건 북마크 여부 조회 엔드포인트가 없어 목록을 페이지 스캔한다.
 * 상세 페이지 아이콘 초기 상태용 — 최대 maxPages 페이지까지만 훑고 못 찾으면 false.
 */
export async function isSpaceBookmarked(
  spaceId: string | number,
  maxPages = 10,
): Promise<boolean> {
  const target = String(spaceId);
  let cursor: string | undefined;
  for (let page = 0; page < maxPages; page += 1) {
    const result = await getMySpaceBookmarks({ cursor, size: 50 });
    if (result.items.some((item) => String(item.spaceId) === target)) {
      return true;
    }
    if (!result.hasNext || !result.nextCursor) {
      return false;
    }
    cursor = result.nextCursor;
  }
  return false;
}
